import { render } from "./ReturnInventory.vue?vue&type=template&id=5c8e565c"
import script from "./ReturnInventory.vue?vue&type=script&lang=js"
export * from "./ReturnInventory.vue?vue&type=script&lang=js"
script.render = render

export default script